import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 0px 0px 15px 15px;

  .select__menu > div {
    height: 70px;
  }
  .inputText {
    padding: 6px 12px;
    :focus {
      border-color: unset;
    }
  }
`
export const BoxIcon = styled.div`
  transition: all 0.6s ease-in;
  border-radius: 50%;
  cursor: ${(props) => (props.disabled ? 'unset' : 'pointer')};
  margin: 0 5px;
  padding: 10px;

  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    transition: all 0.6s ease-in;
    background-color: ${(props) => (props.disabled ? 'unset' : 'rgba(37, 118, 210, 0.04) ')};

    svg,
    path {
      transition: all 0.6s ease-in;

      color: ${(props) => (props.disabled ? 'unset' : '#8E489C')};
    }
  }
`
